import * as State from './rewards.state.type';
import * as Request from './rewards.request.type';
import { Caption } from '../utility-types';

export enum RewardPurchaseStatus {
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

export interface IRewardPurchaseSchedule {
  createdAt: string;
  updatedAt: string;
  id: string;
  approvedDate: string;
  approvedTime: string;
  zoomLink: string;
  communication: [];
  message: string;
  rewardId: string;
  firstDate: string;
  firstTime: string;
  secondDate: string;
  secondTime: string;
  thirdDate: string;
  thirdTime: string;
  subject: string[];
}
export interface IRewardPurchase {
  id: string;
  rewardId: string;
  studentId: string;
  createdAt: string;
  updatedAt: string;
  price: number;
  reward: IReward;
  status: RewardPurchaseStatus;
  schedules: IRewardPurchaseSchedule;
}

export interface IReward {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  description: string;
  price: number;
  thumbnail: State.IThumbnail;
  isUnlocked: boolean;
  purchases?: IRewardPurchase[];
}

export interface IRecordingPurchase {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  description: string;
  price: number;
  thumbnail: State.IThumbnail;
}

export interface ICoinHistory {
  id: string;
  createdAt: string;
  updatedAt: string;
  coins: number;
  studentId: string;
  description: string;
}

export interface IRecording {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  description: string;
  price: number;
  thumbnail: State.IThumbnail;
  type: Request.RecordingType;
  isUnlocked: boolean;
  video?: State.IThumbnail;
  file?: State.IThumbnail[];
  captions: Caption[];
}

export interface ISingleRecording {
  id: string;
  createdAt: string;
  updatedAt: string;
  description: string;
  price: number;
  type: Request.RecordingType;
  recordingId: string;
  studentId: string;
  recording: IRecording;
  document?: Omit<IRecording, 'video' | 'isUnlocked'>;
}

export interface IRewardDashboard {
  rewardPurchases: IRewardPurchase[];
  rewards: IReward[];
  recordingPurchases: IRecordingPurchase[];
  coinsHistory: ICoinHistory[];
  apps: IRecording[];
  webinars: IRecording[];
  workshops: IRecording[];
  resources: IRecording[];
}

export interface IMessageResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  message: string;
  from: string;
  requestId: string;
}
